import { render, staticRenderFns } from "./PasswordRecoveryForm.vue?vue&type=template&id=2e08e7b6&scoped=true&"
import script from "./PasswordRecoveryForm.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecoveryForm.vue?vue&type=style&index=0&id=2e08e7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08e7b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
